module.exports = __webpack_public_path__ + "media/images/icon-check-8220de1ac4e7990fcf76f10b4539a20f.svg";